import { useEffect, useRef } from 'react';

/**CSS */
import './style.css';

export const CustomModal = ({ children, visibility = false, innerRef = null, closeEvent = () => {} }) => {
    function useOutsideAlerter(ref) {
        useEffect(() => {
            /**
            * Alert if clicked on outside of element
            */
            function handleClickOutside(event) {
                if (ref && ref.current && !ref.current.contains(event.target)) {
                    closeEvent();
                }
            }
            
            // Bind the event listener
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                // Unbind the event listener on clean up
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }

    useOutsideAlerter(innerRef);

    return visibility ? 
    (
        <div className="custom-modal-container">
            {children}
        </div>
    ) 
    : 
    null;
}